import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { filter, map, take, takeUntil } from 'rxjs/operators';

import { UserRoleType } from '@vi-iot/client';

import { AuthStore, Department, DepartmentStore } from '@store';
import { MatTooltip } from '@angular/material/tooltip';
import { matTooltipSetter } from '../../../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-departments-dropdown',
  templateUrl: './departments-dropdown.component.html',
  styleUrls: ['./departments-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepartmentsDropdownComponent implements OnInit, OnDestroy {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Input() departmentName: string;

  isSupportInternationalRoleActive = false;
  departmentModel = { name: null };
  departments: Department[];
  savedDepartmentName: string = null;

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private installationId: string;

  constructor(
    private authStore: AuthStore,
    private departmentStore: DepartmentStore,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((param) => {
      this.installationId = param['id'];
    });

    this.authStore
      .getUserIotRole()
      .pipe(
        filter(
          (role) =>
            role === UserRoleType.supportInternational ||
            role === UserRoleType.supportLocalDepartmentManagement ||
            role === UserRoleType.supportInternationalWithRemoteDiagnosis
        ),
        take(1)
      )
      .subscribe(() => (this.isSupportInternationalRoleActive = true));

    this.authStore
      .isRsaUser()
      .pipe(
        filter((isRsaUser) => isRsaUser),
        take(1)
      )
      .subscribe(() => {
        this.departmentStore.readDepartments();
        this.departmentStore.state$
          .pipe(
            takeUntil(this.ngUnsubscribe),
            filter((response) => !isEmpty(response) && !isEmpty(response.departments)),
            map((response) => response.departments.data)
          )
          .subscribe((departments) => {
            departments.map((department) => {
              if (department.name === this.departmentName) {
                this.departmentModel = department;
                this.savedDepartmentName = department.name;
              }
            });
            this.departments = departments.sort((a, b) => a.name.localeCompare(b.name));

            this.cdr.detectChanges();
          });
      });
  }

  deleteDepartment(): void {
    this.departmentModel = { name: null };
    this.savedDepartmentName = null;
    this.departmentStore.deleteDepartment(this.installationId);
    this.cdr.detectChanges();
  }

  saveNewDepartmentName(newDepartmentName: string): void {
    this.savedDepartmentName = newDepartmentName;
    this.departmentStore.putDepartment(newDepartmentName, this.installationId);
  }

  compareObjects(o1: Department, o2: Department): boolean {
    return o1.name === o2.name;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
